import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncParishionerList({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/parishionerList"));
  console.log("Loading", AsyncParishionerList.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncParishionerList;
